// 投放计划格式化
import { BannerConfig } from '@tencent/wphk-components-banner';
import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';
import { getConfigWithLang } from '@/utils';
import { ExpectedPropertyForBanner, LangConfigKey, ThemeItem, ThemeList } from '@/types';
import { MultiJumpContainerType } from '@/types/banner-layout';
import { ContentBaseData, formatContentBaseToMultiJump } from '@tencent/wphk-components-multi-jump-container/src/business';

/**
 * 格式化投放中台返回的banner数据
 */
export function formatBannerData(item: DpItem): BannerConfig {
  const baseData = getConfigWithLang({
    originalObj: item.contentBaseData as ExpectedPropertyForBanner,
    configKey: [LangConfigKey.imgObj, LangConfigKey.bannerAltObj],
  });

  return {
    bannerImgUrl: baseData.imgObj,
    bannerJumpInfo: {
      jumpUrl: baseData.link ?? '',
      miniAppId: baseData.appid ?? '',
      miniAppUsername: baseData.username ?? '',
      miniAppPath: baseData.path ?? '',
    },
    bannerTag: baseData.statClick,
    bannerAlt: baseData.bannerAltObj,
    weight: 0,
  };
}

/**
 * 格式化投放中台返回的MultiContainer数据
 */
export function formatMultiContainerData(item: DpItem): MultiJumpContainerType {
  const formatedData = formatContentBaseToMultiJump(item.contentBaseData as ContentBaseData);
  return {
    biTag: formatedData.biTag,
    /** 调转链接h5 */
    jumpUrl: formatedData.jumpInfo.jumpUrl,
    /** 跳转链接小程序 */
    appid: formatedData.jumpInfo.appid,
    /** 跳转链接小程序用 */
    username: formatedData.jumpInfo.username,
    /** 跳转链接小程序用 */
    path: formatedData.jumpInfo.path,
    /** 图片详情 */
    imgUrl: formatedData.imgUrl,
  };
}

/**
 * 格式化投放中台返回的主题数据
 */
export function formatThemeData(item): ThemeItem {
  const baseData = item.contentBaseData;
  // 主题分类
  if (baseData.themeId) {
    return getConfigWithLang({ originalObj: baseData, configKey: [LangConfigKey.title] });
  }
  // 主题卡片
  return {
    ...formatCardInfoByLang(baseData),
    dpId: String(item.dpId),
  };
}

/**
 * 处理主题分类和主题卡片的关联关系
 */
export function formatThemeList(list: ThemeItem[]): ThemeList[] {
  // @ts-ignore
  const initThemeList: ThemeList[] = list
    .filter(item => 'themeId' in item && item.themeId)
    .map(item => ({ ...item, list: [] }));

  return list
    .filter(item => 'belongThemeId' in item)
    .reduce((result, item) => {
      const themeItem = result.find(ele => 'belongThemeId' in item && ele.themeId === item.belongThemeId);
      if (themeItem) {
        // @ts-ignore
        themeItem.list.push(item);
      }
      return result;
    }, initThemeList);
}

/**
 * 格式化卡片信息（标题、描述、logo）
 * @param originalObj
 * @returns
 */
export function formatCardInfoByLang(originalObj: any) {
  return getConfigWithLang({
    originalObj,
    configKey: [LangConfigKey.title, LangConfigKey.desc, LangConfigKey.logo],
  });
}
